import React from "react";
import { HStack, Text } from "native-base";
import StateIndicator from "./StateIndicator";

type Props = {
  isActive?: boolean;
};

export default function ActiveState({ isActive }: Props) {
  return (
    <HStack space={2}>
      <StateIndicator stateColor={isActive ? "green" : "red"} />
      <Text>{isActive ? "Aktiv" : "Deaktiviert"}</Text>
    </HStack>
  );
}
